// extracted by mini-css-extract-plugin
module.exports = {"PendingLiveCallWrapper":"PendingLiveCallWrapper___2GJMf","blinkingActivity":"blinkingActivity___2V7gm"};